<template>
  <v-app
    class="espd-app"
    v-show="!isBlankRoute"
  >
    <v-toolbar

      color="secondary"
      class="pt-0"
      light
    >
      <div class="d-flex align-center">
        <v-img
          alt="Hilma logo"
          class="shrink mr-2"
          contain
          :src="require('./assets/hilma_logo.png')"
          transition="scale-transition"
          width="40"
        />

        <h1 id="espd-header-title" class="app-header">
          {{$t('header.titleText')}}
        </h1>
      </div>

      <v-spacer />

      <!-- Login and logout -->
      <v-menu
        v-if="isLoggedIn"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-btn
            text
            v-on="on"
          >
            <span>{{ currentUser }}</span>
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-btn
              text
              @click="logout"
            >
              <span class="mr-2">{{$t('header.logOut')}}</span>
              <v-icon>mdi-open-in-new</v-icon>
            </v-btn>
          </v-list-item>
        </v-list>
      </v-menu>
      <span v-if="isLoggedIn">|</span>
      <!-- Language -->
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on">
            <span>{{ currentLang }}</span>
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-btn text link :to="{ params: { lang: 'fi' }, query: { accesstoken: accessToken } }">
              <span>{{$t('header.langFi')}}</span>
            </v-btn>
          </v-list-item>
          <v-list-item>
            <v-btn text link :to="{ params: { lang: 'sv' }, query: { accesstoken: accessToken } }">
              <span>{{$t('header.langSv')}}</span>
            </v-btn>
          </v-list-item>
          <v-list-item>
            <v-btn text link :to="{ params: { lang: 'en' }, query: { accesstoken: accessToken } }">
              <span>{{$t('header.langEn')}}</span>
            </v-btn>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-container
      fill-height
      align-start
      class="pa-0 pa-xs-0"
    >
      <v-main
        class="py-5"
      >
        <router-view />
      </v-main>
    </v-container>
    <v-footer
      color="primary"
      class="justify-center"
    >
      <div class="footer">{{ $t('footer.footerText') }}</div>
    </v-footer>
  </v-app>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { instance } from './services/auth-service'
import { getAccessTokenQueryParameter } from './services/espd-responses'
import store from './store/index'

@Component({})
export default class App extends Vue {
  get isBlankRoute() {
    return !!this.$route?.meta?.blank
  }

  get accessToken() {
    return getAccessTokenQueryParameter(this.$route.query)
  }

  get currentLang() {
    return this.$route.params.lang
  }

  get currentUser() {
    if (this.isLoggedIn?.idToken) {
      return `${this.isLoggedIn.idToken.given_name} ${this.isLoggedIn.idToken.family_name}`
    }

    return undefined
  }

  get isLoggedIn() {
    return instance.getAccount()
  }

  logout() {
    instance.logout()
  }

  created() {
    if (!this.isInIframe()) {
      instance.initialize({
        auth: {
          clientId: store.state.configuration.clientId,
          authority: store.state.configuration.authority,
          validateAuthority: false,
          redirectUri: `${window.location.protocol}//${window.location.host}/login`,
          navigateToLoginRequestUrl: false,
          postLogoutRedirectUri: `${window.location.protocol}//${window.location.host}/`,
        },
        cache: {
          cacheLocation: 'sessionStorage',
          storeAuthStateInCookie: false,
        },
        scopes: [store.state.configuration.scope],
      })
    }
  }

  isInIframe(): boolean {
    try {
      return window.self !== window.top
    } catch (e) {
      return true
    }
  }
}
</script>

<style lang="scss">
@import "@/sass/variables.scss";
@import "@/sass/vue-treeselect.scss";
@import "@/sass/global.scss";

.espd-app {
  h1.app-header {
    color: $brand-color2;
    font-size: 1.5rem;
  }

  .footer {
    color: $brand-grey3;
  }
}
</style>
